import axios from '../../apis/axios';
import Axios from 'axios';
import jwt_decode from 'jwt-decode';
import toast from 'react-hot-toast';
import { userActionType } from './user.action.type';
import store from '../store'

export const setCurrentUser = (user) => ({
  type: userActionType.SET_CURRENT_USER,
  payload: user,
});

const JWT_META_KEYS = new Set(['exp', 'iat', 'nbf', 'iss', 'aud', 'jti']);

function deriveUserFromJwtPayload(decoded) {
  if (!decoded || typeof decoded !== 'object') return null;
  if (decoded.user && typeof decoded.user === 'object' && !Array.isArray(decoded.user)) {
    return { ...decoded.user };
  }
  const user = {};
  for (const [key, value] of Object.entries(decoded)) {
    if (!JWT_META_KEYS.has(key)) user[key] = value;
  }
  if (!user._id && decoded.sub) user._id = decoded.sub;
  return Object.keys(user).length ? user : null;
}

/**
 * Persists the same session shape as email/password login (localStorage + storage event).
 * refreshToken is optional and used for CyberArk / SSO flows.
 */
export function persistAuthSession({ user, token, refreshToken }) {
  const mergedUser = { token, ...user };
  localStorage.setItem('user', JSON.stringify(mergedUser));
  localStorage.setItem('token', token);
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    localStorage.removeItem('refreshToken');
  }
  window.dispatchEvent(new Event('storage'));
}

/**
 * CyberArk (or other IdP) redirects here with ?token=…&refreshToken=…
 * Tries /auth/me first when available; otherwise builds the user from JWT claims.
 */
export const completeSsoLogin = (token, refreshToken) => async (dispatch) => {
  let userPayload = null;

  const base = process.env.REACT_APP_API_URL;
  if (base) {
    try {
      const { data } = await Axios.get(`${base}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      userPayload = data?.user ?? data?.data?.user ?? data?.data ?? data;
    } catch {
      // No profile endpoint or not authenticated yet — fall back to JWT body.
    }
  }

  if (!userPayload || typeof userPayload !== 'object') {
    try {
      userPayload = deriveUserFromJwtPayload(jwt_decode(token));
    } catch {
      toast.error('Invalid or expired login link.');
      return;
    }
  }

  if (!userPayload || typeof userPayload !== 'object') {
    toast.error('Could not load your profile from SSO.');
    return;
  }

  dispatch(setCurrentUser({ token, ...userPayload }));
  persistAuthSession({ user: userPayload, token, refreshToken });
  window.location.href = '/dashboard';
};

export const setNotification = (notif) => ({
  type: userActionType.ADD_NOTIFICATION,
  payload: notif,
});

export const setNotifications = (notifs) => ({
  type: userActionType.ADD_NOTIFICATIONS,
  payload: notifs,
});
export const loginUser = (user, navigate) => async (dispatch) => {
  const myPromise = axios({
    method: 'post',
    data: {
      ...user,
    },
    url: `/auth/login`,
  });
  toast.promise(myPromise, {
    loading: 'Loading',
    success: (data) => {
      if(data?.data){
        const { token, user: profile, refreshToken } = data.data;
        dispatch(setCurrentUser({ token, ...profile }));
        persistAuthSession({
          user: profile,
          token,
          refreshToken,
        });
        window.location.href = ("/dashboard");
        return `Successfully Logged in`;
      }else{
        return `Something went wrong`
      }
    },
    error: (err) =>
      err.response.data.error ||
      err.response.data.message ||
      err.message ||
      'Something went wrong',
  });
};

export const logOutUser = (navigate) => async (dispatch) => {
  const user = store.getState().user?.currentUser
  const myPromise = axios({
    method: 'post',
    data: {
        isLoggedInFromAdminPortal: false,
      id: user?._id,
    },
    url: `auth/updateUser/logout`
  });
  toast.promise(myPromise, {
    loading: 'Loading',
    success: (data) => {
      dispatch(setCurrentUser(null));
      localStorage.clear();
      window.dispatchEvent(new Event("clearStorage"));
      navigate("/login")
      return 'Successfully Logged out';
    
    },
    error: (err) =>
      err.response.data.error ||
      err.response.data.message ||
      err.message ||
      'Something went wrong',
  });
};

export const addNotification = (notification) => async (dispatch) => {
  console.log("adding notification")
  const user = store.getState().user?.currentUser
  console.log({notification})
  dispatch(setNotification(notification));
};

export const addNotifications = (notifications) => async (dispatch) => {
  console.log("adding notifications")
  const user = store.getState().user?.currentUser
  console.log({notifications})
  dispatch(setNotifications(notifications));
};